import {StyleRepository} from '@domain/model/Style/StyleRepository';

const FillBirthdate = async (repository: StyleRepository, customerId: string, birthdate: string): Promise<void> => {
  if (!customerId || !birthdate) return;
  await repository.fillBirthdate({customerId, birthdate});
};

export {FillBirthdate};
